<template>
  <div
    class="select-wrapper">
    <select
      v-model="value"
      @input.native="handlerInput"
      @change="handlerChange"
      :placeholder="placeholder"
      :disabled="disabled"
      @focus="handlerFocus"
      @paste.native="handlePaste"
      ref="select">
      <template v-if="!multiple">
        <option disabled>{{L10n('please-choose')}}</option>
      </template>
      <slot name="select-info" />
      <option
        v-for="item in showedData"
        :key="item[fields.id]"
        :value="getLabel(item)"
        :disabled="!!item.disabled"
      >
        {{item[fields.title]}}
      </option>
    </select>
    <span class="arrow"/>
  </div>
</template>

<script>
import { select, selectMobile } from './mixins'
export default {
  name: 'Mobile',
  mixins: [select, selectMobile]
}
</script>
